

































































import { createComponent, computed } from "@vue/composition-api";

import {
  BaseTabControl,
  BaseTabControlHeaders,
  BaseTabControlHeadersItem,
  BaseTabControlContent,
  BaseTabControlContentItem,
  BaseDrinksOnDay,
  BaseDrinkCounter
} from "@web-components";
// eslint-disable-next-line
import { DrinkingDay } from "@dcc/types/drinkingDay";
// eslint-disable-next-line
import { DayOfWeek, DaysDescription } from "@dcc/types/dayOfWeek";
// eslint-disable-next-line
import { AverageDay } from "@dcc/types/averageDay";
/*eslint-disable */
import {
  DrinkingDayTabEnabled,
  replaceSpacesWithDashes
} from "@dcc/common/drinkingDayUtils";
/*eslint-enable */
import { Drinks } from "@dcc/types/drinks";
import { getDrinkDescriptions } from "@dcc/constants/drinkConstants";

export interface DrinkTotals extends DrinkingDay {
  day: DayOfWeek | AverageDay;
  amount: number;
}

interface DrinkingTabs {
  drinksPerDay: DrinkTotals[];
  min: number;
  max: number;
  currentTab: number;
  tabsEnabled: DrinkingDayTabEnabled;
  labelMap: DaysDescription;
}

export default createComponent({
  components: {
    BaseTabControl,
    BaseTabControlHeaders,
    BaseTabControlHeadersItem,
    BaseTabControlContent,
    BaseTabControlContentItem,
    BaseDrinksOnDay,
    BaseDrinkCounter
  },
  model: {
    prop: "currentTab",
    event: "input"
  },
  props: {
    drinksPerDay: {
      type: Array as () => DrinkTotals[],
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    tabsEnabled: {
      type: Object as () => DrinkingDayTabEnabled,
      required: true
    },
    currentTab: {
      type: Number,
      required: true
    },
    labelMap: {
      type: Object as () => DaysDescription,
      required: true
    }
  },
  setup(props: DrinkingTabs, { emit }) {
    const localCurrentTab = computed({
      get: () => {
        return props.currentTab;
      },
      set: val => {
        emit("input", val);
      }
    });

    const drinkDescriptions = getDrinkDescriptions();

    const getImageName = (drinkName: string) => {
      return (
        "https://drinkaware-web.azureedge.net/tools/tools/" +
        drinkName.charAt(0).toUpperCase() +
        drinkName.slice(1) +
        ".svg"
      );
    };

    return {
      drinkDescriptions,
      localCurrentTab,
      getImageName,
      Drinks,
      replaceSpacesWithDashes
    };
  }
});
